import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../core/providers/AuthProvider';
import { useProfile } from '../../../profile/hooks/useProfile';
import ProfilePosts from '../../../profile/components/ProfilePosts';
import { Spinner } from '../../../../core/design-system/components/Spinner';
import './styles.css';

const MyActivitiesPage = () => {
  const { t } = useTranslation('profile');
  const { user: currentUser } = useAuth();
  const [activeTab, setActiveTab] = useState('posts');
  
  const { 
    posts, 
    participations, 
    loading, 
    error
  } = useProfile(currentUser?.uid);

  if (loading) {
    return (
      <div className="my-activities-page">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="my-activities-page">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="my-activities-page">
      <div className="activities-tabs">
        <button 
          className={`tab ${activeTab === 'posts' ? 'active' : ''}`}
          onClick={() => setActiveTab('posts')}
        >
          {t('tabs.posts')}
        </button>
        <button 
          className={`tab ${activeTab === 'participations' ? 'active' : ''}`}
          onClick={() => setActiveTab('participations')}
        >
          {t('tabs.participations')}
        </button>
      </div>

      <div className="activities-content">
        {activeTab === 'posts' ? (
          <ProfilePosts posts={posts} />
        ) : (
          <ProfilePosts posts={participations} />
        )}
      </div>
    </div>
  );
};

export default MyActivitiesPage;

